import { useEffect } from 'react'
import { Container, Typography } from '@mui/material'
import { Box } from '@mui/system'
import Calalulator from './Calalulator'

const sectionHeading = 'PRESALE'

const PreSale = () => {
  useEffect(() => {
    window.scrollTo({ top: 0 })
  }, [])

  return (
    <>
      <Box mt={15} id="preSale">
        <Container>
          <Box sx={{ position: 'relative', textAlign: 'center' }} mb={10}>
            <Box>
              {' '}
              <span className="textStroke">
                <Typography
                  color="white"
                  fontSize={{ xs: '31px', sm: '50px', md: '74px' }}
                  sx={{ letterSpacing: '0.12em' }}
                >
                  {sectionHeading}
                </Typography>
              </span>
            </Box>
            <Box
              sx={{
                position: 'absolute',
                top: '10%',
                right: 0,
                left: 0,
                margin: 'auto',
              }}
            >
              <Typography
                color="white"
                fontSize={{ xs: '25px', sm: '40px', md: '64px' }}
                sx={{ letterSpacing: '0.12em' }}
              >
                {sectionHeading}
              </Typography>
            </Box>
          </Box>
          {/* Calulator is down here */}

          <Box sx={{ position: 'relative', textAlign: 'center' }} mb={10}>
            <Box>
              {' '}
              <span className="textStroke">
                <Typography
                  color="white"
                  fontSize={{ xs: '31px', sm: '50px', md: '74px' }}
                  sx={{ letterSpacing: '0.12em' }}
                >
                  Coming Soon
                </Typography>
              </span>
            </Box>
            <Box
              sx={{
                position: 'absolute',
                top: '10%',
                right: 0,
                left: 0,
                margin: 'auto',
              }}
            >
              <Typography
                color="white"
                fontSize={{ xs: '25px', sm: '40px', md: '64px' }}
                sx={{ letterSpacing: '0.12em' }}
              >
                Coming Soon
              </Typography>
            </Box>
          </Box>
          {/* <Calalulator /> */}

          {/* <Box width={{xs:'95%',md:'50%'}} margin='50px auto auto auto'>
          {['Want to raise $500,000',
            '20 Million Tokens for sale',
            'Price per token during launch: 0.025',
            'Price at launch: 0.027',
          ].map((item)=> <Typography color='white'> {item}</Typography> )}</Box> */}
        </Container>
      </Box>
    </>
  )
}

export default PreSale
